export class CheckAzureVMNameExistsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cloudAccountId",
            "baseName": "cloudAccountId",
            "type": "string",
            "format": "tobedefined"
        },
        {
            "name": "resourceGroup",
            "baseName": "resourceGroup",
            "type": "string",
            "format": "tobedefined"
        },
        {
            "name": "vmName",
            "baseName": "vmName",
            "type": "string",
            "format": "tobedefined"
        }
    ];
    static getAttributeTypeMap() {
        return CheckAzureVMNameExistsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
